// extracted by mini-css-extract-plugin
module.exports = {"addSpacingToParagraphs":"HtmlSection-module--addSpacingToParagraphs--2_fsw","useTextAlignLeftForHeadlines":"HtmlSection-module--useTextAlignLeftForHeadlines--2e5BV"};